import { ErrorHandler, Injectable } from '@angular/core';

/**
 * Logs the REAL error details. The default handler / global listeners serialize
 * errors with JSON, but a plain `Error` has non-enumerable `message`/`stack`, so
 * they show up as `{}` in the Xcode/Capacitor console — useless for debugging.
 * This prints name/message/stack explicitly so native runtime errors are legible.
 */
@Injectable()
export class VerboseErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    const e = (error as { rejection?: unknown })?.rejection ?? error;
    const err = e as {
      name?: string;
      code?: string;
      message?: string;
      stack?: string;
      cause?: {
        filename?: string;
        lineno?: number;
        colno?: number;
        message?: string;
      };
      filename?: string;
      lineno?: number;
      colno?: number;
    };
    console.error(
      '[AppError]',
      err?.name ?? 'Error',
      '| code:',
      err?.code ?? '-',
      '| message:',
      err?.message ?? String(e),
      '| file:',
      err?.filename ?? err?.cause?.filename ?? '-',
      '| line:',
      err?.lineno ?? err?.cause?.lineno ?? '-',
      '| col:',
      err?.colno ?? err?.cause?.colno ?? '-',
      '| stack:',
      err?.stack ?? '-'
    );
  }
}
